var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPrevizBlanc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 70,
    viewBox: "0 0 228 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.501129 12.3016L12.0255 21.0821V52.9112L0.501129 44.1308V12.3016Z",
    fill: "#CFDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0255 52.9112L23.5498 44.1308V12.3016L12.0255 21.0821V52.9112Z",
    fill: "#84ADFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0254 3.93273L23.6183 12.3016L12.0254 21.0667L0.501035 12.3016L12.0254 3.93273Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5577 20.379L40.082 28.765V60.5942L28.5577 51.8137V20.379Z",
    fill: "#CFDFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.082 60.5942L51.6064 51.8137V19.9845L40.082 28.765V60.5942Z",
    fill: "#84ADFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0821 11.6156L51.6751 19.9845L40.0821 28.7497L28.5578 20.3961L40.0821 11.6156Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0332 39.765L28.5576 48.5454V69.3746L17.0332 60.5941V39.765Z",
    fill: "#EDF3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5575 69.3746L40.0819 60.5941V39.765L28.5575 48.5454V69.3746Z",
    fill: "#CFDFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5577 31.3961L40.0918 39.765L28.5577 48.5301L17.0333 39.765L28.5577 31.3961Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2015 12.403H64.2415V57.203H74.4815V43.123H81.2015C90.0335 43.123 96.8815 36.275 96.8815 27.763C96.8815 19.251 90.0335 12.403 81.2015 12.403ZM81.2015 33.523H74.4815V22.003H81.2015C84.3375 22.003 86.6415 24.499 86.6415 27.763C86.6415 31.027 84.3375 33.523 81.2015 33.523Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.046 30.899V25.203H99.4465V57.203H109.046V42.739C109.046 36.403 114.678 34.803 118.646 35.443V24.563C114.614 24.563 110.326 26.611 109.046 30.899Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.172 45.043H151.892C152.148 43.827 152.276 42.547 152.276 41.203C152.276 31.539 145.364 24.307 136.02 24.307C125.908 24.307 118.996 31.667 118.996 41.203C118.996 50.739 125.78 58.099 136.724 58.099C142.804 58.099 147.54 55.859 150.676 51.507L142.996 47.091C141.716 48.499 139.476 49.523 136.852 49.523C133.332 49.523 130.388 48.371 129.172 45.043ZM128.98 37.875C129.876 34.611 132.308 32.819 135.956 32.819C138.836 32.819 141.716 34.163 142.74 37.875H128.98Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.287 25.203L168.631 45.491L161.975 25.203H151.351L163.191 57.203H174.071L185.911 25.203H175.287Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.634 22.387C195.77 22.387 198.394 19.763 198.394 16.627C198.394 13.491 195.77 10.867 192.634 10.867C189.498 10.867 186.874 13.491 186.874 16.627C186.874 19.763 189.498 22.387 192.634 22.387ZM187.834 57.203H197.434V25.203H187.834V57.203Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.763 48.243L226.859 31.603V25.203H202.539V34.163H213.995L201.899 50.803V57.203H227.499V48.243H214.763Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrevizBlanc);
export default __webpack_public_path__ + "static/media/logo_previz_blanc.b2d5c8c836295e9d89d153624f570230.svg";
export { ForwardRef as ReactComponent };